import React from 'react'
import { withFirebase } from '../../firebase';
import '@lourenci/react-kanban/dist/styles.css'
import GroupForm from './GroupForm';
import MatchesList from '../MatchesList/MatchesList';
import EliminationForm from './EliminationForm';
import { clasifiedTeams } from '../../TeamList/TeamsUtil'

const WorldCupForm = (props) => {

    const { loading, tournament, teams } = props;


    if (loading)
        return (
            <div className="nav justify-content-center pt-2">
                <small className="font-italic">Cargando...</small>
            </div>
        )

    if (!tournament.matchesGroupGenerated) {
        return <GroupForm {...props} />
    }

    const cTeams = clasifiedTeams(teams);

    return (
        <div className="col-12 bg-white border border-white text-decoration-none  p-0 mb-2 ">
            <nav className="small">
                <div className=" nav nav-tabs  justify-content-center flex-row font-weight-bold" id="nav-tab" role="tablist">

                    <a className={" nav-item nav-link tab-material active text-center text-dark "} id="nav-group-tab" data-toggle="tab" href="#nav-group" role="tab" aria-controls="nav-group" aria-selected="true">
                        <span>Fase de Grupos</span>
                    </a>

                    <a className={" nav-item nav-link tab-material text-center text-dark "} id="nav-elimination-tab" data-toggle="tab" href="#nav-elimination" role="tab" aria-controls="nav-elimination" aria-selected="false">
                        <span>Eliminatoria</span>
                    </a>

                </div>
            </nav>

            <div className="tab-content pt-2" id="nav-tabContent">

                <div className="tab-pane fade active show" id="nav-group" role="tabpanel" aria-labelledby="nav-group-tab">
                    <MatchesList {...props} />
                </div>

                <div className="tab-pane fade " id="nav-elimination" role="tabpanel" aria-labelledby="nav-elimination-tab">
                    <EliminationForm {...props} teams={cTeams} />
                </div>

            </div>

        </div>
    );
}

export default withFirebase(WorldCupForm);


